import { Icon, IconProps } from '@chakra-ui/react';

export const UploadIcon = (props: IconProps) => (
  <Icon width='24px' height='24px' viewBox='0 0 24 24' fill='none' stroke='#160C45' {...props}>
    <path
      d='M11.9992 12.0002V21.0002M11.9992 12.0002L9.49923 14.0002M11.9992 12.0002L14.4992 14.0002M5.03323 9.11719C4.08744 9.35518 3.26111 9.93035 2.70948 10.7346C2.15786 11.5389 1.91891 12.5169 2.03754 13.485C2.15616 14.453 2.62419 15.3444 3.35369 15.9917C4.0832 16.639 5.02396 16.9976 5.99923 17.0002H6.99923'
      stroke='inherit'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M15.8287 7.13821C15.4869 5.78478 14.6433 4.61195 13.4688 3.85746C12.2944 3.10298 10.877 2.8233 9.50395 3.07511C8.13093 3.32692 6.90503 4.09139 6.07476 5.21354C5.24448 6.3357 4.87195 7.73157 5.03269 9.11821C5.03269 9.11821 5.18569 10.0002 5.49869 10.5002'
      stroke='inherit'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M17 17C17.706 16.9995 18.404 16.8495 19.0479 16.5599C19.6917 16.2702 20.267 15.8475 20.7357 15.3195C21.2045 14.7915 21.5561 14.1702 21.7674 13.4965C21.9787 12.8229 22.045 12.1121 21.9618 11.4109C21.8786 10.7098 21.6479 10.0343 21.2848 9.42874C20.9217 8.82321 20.4345 8.30145 19.8552 7.89778C19.276 7.49412 18.6178 7.21772 17.924 7.08676C17.2302 6.9558 16.5166 6.97327 15.83 7.138L14.5 7.5'
      stroke='inherit'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Icon>
);
